export const environment = {
  production: false,
  baseUrl: "https://campaign-api.admore.app/api/",
};